<template>
  <section class="wrapper">
    <LMap
      :zoom="currentZoom"
      :center="selectedMarker"
      @update:center="centerUpdate"
    >
      <LTileLayer :url="url" :attribution="attribution" />
      <LMarker :lat-lng="selectedMarker">
        <LTooltip :options="{ permanent: true, interactive: true, direction: 'top' }">
          <div>
            Coordinate: {{selectedMarker}}<br/>
            <b-button @click="selectLocation">
              Select Location
            </b-button>
          </div>
        </LTooltip>
      </LMarker>
    </LMap>
  </section>
</template>

<style lang="scss" scoped>
.wrapper {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  width: 100%;
  height: 90vh;
}
</style>

<script>
import {latLng} from 'leaflet'
import {LMap, LTileLayer, LMarker, LTooltip} from 'vue2-leaflet'

const DEFAULT_CENTER = latLng(-6.231994, 106.860264)
const DEFAULT_ZOOM = 7

export default {
  name: 'SelectLocation',
  props: {
    marker: {
      type: Object
    },
    center: {
      type: Object,
      default: () => DEFAULT_CENTER
    },
    zoom: {
      type: Number,
      default: () => DEFAULT_ZOOM
    }
  },
  data () {
    return {
      selectedMarker: DEFAULT_CENTER,
      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentZoom: DEFAULT_ZOOM
    }
  },
  created () {
    this.init()
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip
  },
  methods: {
    centerUpdate(center) {
      this.selectedMarker = center
    },
    init () {
      if (this.marker) {
        this.selectedMarker = this.marker
      } else {
        this.centerUpdate(this.center)
      }
      this.currentZoom = this.zoom
    },
    selectLocation () {
      this.$emit('selectLocation', this.selectedMarker)
    }
  }
}
</script>
